<template>
  <div 
    ref="tagList" 
    class="tagList" 
    :class="tagOptionPopListViewBln ? 'open' : null " 
  >
    <ul>
      <li 
        v-for="tag in tags" 
        :style="{ '--bg-color' : tag.color }"
      >
        <button @click="clickHandler( tag )">
          <i class="icon"></i>
          <span>{{ tag.name }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { tagsArr } from "@/plugins/wApi/colors";
import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew"; 
import TagAddPopComm from "@TagAddPop/TagAddPopComm"; 

export default {
  mixins : [ TagAddPopComm ] , 
  computed : {
  } , 
  data () {
    return {
      tags : tagsArr , 
    } 
  } , 
  watch : {
    tagOptionPopListViewBln : {
      immediate : true , 
      handler ( newBln ) {
        let { 
          $refs : { tagList } , 
          pos : { x , y } , 
        } = this ; 
        let { innerWidth , innerHeight } = window ; 
        let gap = 32 ; 
        let cornerGap = 20 ; 
        
        const setPosFunc = _=> {
          let posX = innerWidth <= tagList.offsetWidth + x + gap + cornerGap 
            ? x - gap - tagList.offsetWidth 
            : x + gap ; 
          let posY = innerHeight <= tagList.offsetHeight + y + cornerGap 
            ? y - gap / 2 + gap - tagList.offsetHeight 
            : y - gap / 2 ; 
          
          tagList.style.left = `${ posX }px` ; 
          tagList.style.top = `${ posY }px` ; 
        } ; // end of setPosFunc 

        if ( newBln == true && tagList ) setPosFunc() ; 
      } , 
    } , 
  } , 
  mounted () {
    this.addTagPopContainerList({ obj : { tagList : this.$refs.tagList }}) ; 
    window.addEventListener('popstate', this.unmountHandler ) ;
  } , 
  methods : {
    unmountHandler () {
      window.removeEventListener('popstate', this.unmountHandler ) ;
      this.setTagOptionPopListViewBln({ bln : false }) ; 
    } , 

    clickHandler ( tag ) {
      this.$emit("callOpenDictionaryPopup",tag);
      // this.setCrntTagType({ tag }) ; 
      // this.setTagOptionPopAddListViewBln({ bln : true }) ; 
      // this.setTagOptionPopListViewBln({ bln : false }) ; 
      // this.setEmptyProcess({ bln : false }) ; 
      // tag.type
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
  .tagList {
    position: fixed; 
    left: 50%; top: 50%; 
    z-index: 10; 
    visibility: hidden; 
    $btnViewTimer: 0.245s; 
    $btnViewDelayTimer: 0.065s; 
    $listViewTimer: $btnViewTimer * 5 - $btnViewDelayTimer * 5; 

    transition: visibility $listViewTimer , opacity $listViewTimer; 
    opacity: 0; 

    ul {
      display: flex; 
      flex-direction: column; 
      gap: 10px; 
      > li {
        > button {
          --btn-height: 33px; 
          width: 100px; 
          height: 33px; 
          border-radius: calc( var( --btn-height ) / 2 ); 
          box-shadow: 0px 4px var( --default-gap ) rgba(91, 91, 91, 0.3);

          background-color: var( --bg-color ); 
          color: $white; 
          font-size: 14px;
          display: flex; 
          align-items: center; 
          padding-left: var( --default-gap ); 
          gap: calc( var( --default-gap ) / 2); 

          opacity: 0; 
          transition: opacity $btnViewTimer; 
          transition-timing-function: ease-in-out;

          @include text-prt-m; 

          .icon {
            --icon-width: 12px; 
            --icon-height: 2px; 
            position: relative; 
            width: var( --icon-width ); 
            height: var( --icon-width ); 

            &::before , &::after {
              content: ''; 
              display: flex; 
              background-color: $white; 
              position: absolute; 
            }
            &::before {
              width: var( --icon-width ); 
              height: var( --icon-height ); 
              left: calc( 50% - var( --icon-width ) / 2 );
              top: calc( 50% - var( --icon-height ) / 2 );
            } 
            &::after {
              height: var( --icon-width ); 
              width: var( --icon-height ); 
              left: calc( 50% - var( --icon-height ) / 2 );
              top: calc( 50% - var( --icon-width ) / 2 );
            } 
          } // end of .icon 
        } // end of button 
      } //end of li 
    } // end of ul 

    &.open {
      visibility: visible; 
      // transform: scale( 1 );
      // transition: visibility $time; 
      transition: none;
      opacity: 1; 

      ul > li {
        > button {
          opacity: 1; 
        }
        &:nth-child(1) > button {
          transition-delay: $btnViewDelayTimer * 0;
        }
        &:nth-child(2) > button {
          transition-delay: $btnViewDelayTimer * 1;
        }
        &:nth-child(3) > button {
          transition-delay: $btnViewDelayTimer * 2;
        }
        &:nth-child(4) > button {
          transition-delay: $btnViewDelayTimer * 3;
        }
        &:nth-child(5) > button {
          transition-delay: $btnViewDelayTimer * 4;
        }
      }
    }
  }
    
</style>